module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "middle-dialog",
    attrs: {
      "title": "流程提交",
      "close-on-click-modal": false,
      "before-close": _vm.handleClose,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "rt-flowsubmit-dialog"
  }, [_c('h2', [_vm._v("选择签核流程\n      "), _c('span', [_vm._v("(下拉框中可能存在多个可选项目,请注意选择合适的流程)")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('el-select', {
    model: {
      value: (_vm.selectedFlowId),
      callback: function($$v) {
        _vm.selectedFlowId = $$v
      },
      expression: "selectedFlowId"
    }
  }, _vm._l((_vm.flowList), function(flow) {
    return _c('el-option', {
      key: flow.new_flowid,
      attrs: {
        "value": flow.new_flowid,
        "label": flow.new_name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h2', [_vm._v("选择签核用户\n        "), _c('span', [_vm._v("(下拉框中可能存在多个可选人员,请注意选择合适的下一级呈递人)")])]), _vm._v(" "), (_vm.stepList != null && _vm.stepList.length > 0) ? _vm._l((_vm.stepList), function(step) {
    return _c('div', {
      key: step.new_flowstepsid
    }, [_c('br'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(step.new_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-select', {
      model: {
        value: (step.selectedUserId),
        callback: function($$v) {
          _vm.$set(step, "selectedUserId", $$v)
        },
        expression: "step.selectedUserId"
      }
    }, _vm._l((step.new_stepusers), function(user) {
      return _c('el-option', {
        key: user.systemuserid,
        attrs: {
          "value": user.systemuserid,
          "label": user.fullname
        }
      })
    }), 1)], 1)
  }) : _c('div', {
    staticStyle: {
      "height": "100px",
      "line-height": "100px",
      "text-align": "center",
      "color": "#888888"
    }
  }, [_vm._v("\n          无审批步骤\n      ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.canSubmit) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmiting
    },
    on: {
      "click": _vm.submitFlow
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c62e2b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/flow/src/submit-dialog.vue
// module id = 1365
// module chunks = 101